import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { CLINIC_ADDRESS, CLINIC_EMAIL, CLINIC_PHONE, CLINIC_PHONE_TEL } from '../config/clinic.config';
import BackButton from './BackButton';
import './ContactUs.css';

const ContactUs = ({ onBackClick }) => {
  const mapContainerStyle = {
    height: '400px',
    width: '100%',
  };

  // Approx. Bahria Town Phase 8, Rawalpindi
  const center = {
    lat: 33.5651,
    lng: 73.1269,
  };

  const markerPosition = {
    lat: 33.5651,
    lng: 73.1269,
  };

  return (
    <div className="contact-us">
      {onBackClick && <BackButton onClick={onBackClick} />}
      <LoadScript googleMapsApiKey="AIzaSyA-ExampleKey1234567890abcdeFGHIJklmnopQRsTUV">
        <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={15}>
          <Marker position={markerPosition} />
        </GoogleMap>
      </LoadScript>

      <div className="contact-us-content">
        <div className="contact-form">
          <h2>Get in Touch</h2>
          <form>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input type="tel" id="phone" name="phone" required />
              </div>
            </div>
            <div className="message-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" required></textarea>
            </div>
            <button type="submit">Send Message</button>
          </form>
        </div>
        <div className="contact-address">
          <h3>Address</h3>
          <p>{CLINIC_ADDRESS}</p>
          <hr />
          <h4>Phone</h4>
          <p>
            <a href={`tel:${CLINIC_PHONE_TEL}`}>{CLINIC_PHONE}</a>
          </p>
          <hr />
          <h4>Email</h4>
          <p>
            <a href={`mailto:${CLINIC_EMAIL}`}>{CLINIC_EMAIL}</a>
          </p>
          <hr />
          <h4>Opening Time</h4>
          <p>Mon-Sat 9:00 AM - 9:00 PM</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
